var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22q-1.875 0-3.512-.712-1.638-.713-2.85-1.926-1.213-1.212-1.925-2.85Q2 14.875 2 13q0-3.75 2.625-6.375T11 4h.15L9.6 2.45 11 1l4 4-4 4-1.4-1.45L11.15 6H11Q8.075 6 6.038 8.037 4 10.075 4 13q0 2.925 2.038 4.962Q8.075 20 11 20q.875 0 1.725-.212.85-.213 1.625-.638l1.45 1.45q-1.075.7-2.3 1.05-1.225.35-2.5.35Zm6-3-6-6 6-6 6 6Zm0-2.85L20.15 13 17 9.85 13.85 13ZM17 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate_left.5064598167a692572922993ed07c59c0.svg";
export { ForwardRef as ReactComponent };